import { useEffect, useState } from 'react'
import { useOutletContext } from 'react-router-dom'
import type { Agent, AgentRunLog } from '@/types'
import { listAgentRunLogs } from '@/lib/api'
import { DataTable, type Column } from '@/components/ui/DataTable'
import { StatusDot } from '@/components/ui/StatusDot'
import { PendingBackendNotice } from '@/components/ui/EmptyState'

export function AgentPerformanceTab() {
  const { agent } = useOutletContext<{ agent: Agent }>()
  const [logs, setLogs] = useState<AgentRunLog[]>([])

  useEffect(() => {
    listAgentRunLogs(agent.id).then(setLogs)
  }, [agent.id])

  const columns: Column<AgentRunLog>[] = [
    { header: 'Run', cell: (r) => r.id, mono: true },
    { header: 'Tipo', cell: (r) => r.run_type },
    { header: 'Cuándo', cell: (r) => new Date(r.run_at).toLocaleString('es-CR') },
    { header: 'Estado', cell: (r) => <StatusDot status={r.status} showLabel={false} /> },
    { header: 'Modelo', cell: (r) => r.model ?? '—', mono: true },
    { header: 'Tokens', cell: (r) => r.tokens_used?.toLocaleString() ?? '—', mono: true },
    { header: 'Duración', cell: (r) => r.duration_ms ? `${r.duration_ms}ms` : '—', mono: true },
  ]

  return (
    <div>
      <PendingBackendNotice endpoint={`GET /agents/${agent.id}/runs`} />
      <DataTable columns={columns} rows={logs} getRowKey={(r) => r.id} />
    </div>
  )
}
